import { FC } from "react";

import { Space, Typography } from "antd";

const FormLabel: FC<{ label: string; description?: string | null; required?: boolean }> = ({
  label,
  description,
  required,
}) => {
  return (
    <Space align={"start"}>
      {required && <Typography.Text type={"danger"}>*</Typography.Text>}
      <Space direction={"vertical"} size={4}>
        {label && <Typography.Text>{label}</Typography.Text>}
        {description && <Typography.Text type="secondary">{description}</Typography.Text>}
      </Space>
    </Space>
  );
};

export default FormLabel;
